<div class="app-select-wrap" [class.default-option]="isDefaultValue">
  <mat-select
    [id]="inputId"
    [attr.data-testid]="testId"
    class="form-control"
    [ngClass]="sizeClass"
    [class.is-invalid]="showError"
    [formControl]="control"
    [multiple]="multiple"
    [disabled]="disabled"
    [panelClass]="panelClass"
    [placeholder]="triggerLabel || placeholder || emptyLabel | translate"
    (selectionChange)="onSelectionChange($event)"
    (openedChange)="openedChange.emit($event)"
  >
    <!-- Caller-provided panel furniture (e.g. an in-panel search box). -->
    <ng-content select="[panel-content]"></ng-content>

    <mat-option *ngIf="!multiple && emptyLabel" [value]="emptyValue">
      {{ emptyLabel | translate }}
    </mat-option>

    <mat-option
      *ngFor="let option of options; trackBy: trackByValue"
      [value]="optValue(option)"
      [attr.data-testid]="optionTestId"
      [disabled]="option.disabled"
    >
      <ng-container
        *ngIf="optionTemplate; else flatOptLabel"
        [ngTemplateOutlet]="optionTemplate"
        [ngTemplateOutletContext]="{ $implicit: option }"
      ></ng-container>
      <ng-template #flatOptLabel>{{
        optLabel(option) | translate
      }}</ng-template>
    </mat-option>

    <mat-optgroup
      *ngFor="let group of optionGroups; trackBy: trackByGroupLabel"
      [label]="groupLabel(group)"
    >
      <mat-option
        *ngFor="let option of groupOptions(group); trackBy: trackByValue"
        [value]="optValue(option)"
        [disabled]="option.disabled"
      >
        {{ optLabel(option) | translate }}
      </mat-option>
    </mat-optgroup>

    <mat-select-trigger *ngIf="!multiple || triggerLabel">
      <span class="app-select-value-wrap">
        <ng-content select="[trigger-prefix]"></ng-content>
        <span class="app-select-value">
          <ng-container
            *ngIf="
              optionTemplate && !triggerLabel && selectedOption;
              else triggerText
            "
            [ngTemplateOutlet]="optionTemplate"
            [ngTemplateOutletContext]="{ $implicit: selectedOption }"
          ></ng-container>
          <ng-template #triggerText>{{
            triggerLabel || selectedLabel | translate
          }}</ng-template>
        </span>
      </span>
    </mat-select-trigger>
  </mat-select>

  <i class="fas fa-chevron-down app-select-chevron"></i>
</div>

<div class="invalid-feedback d-block" *ngIf="showError && showValidation">
  <span *ngIf="errorText?.trim()">{{ errorText }}</span>
  <span *ngIf="!errorText?.trim()">{{ errorMessageKey | translate: {} }}</span>
</div>

<app-explanation *ngIf="helpText" [text]="helpText"></app-explanation>

<div *ngIf="warningText" class="invalid-feedback d-block app-select-warning">
  {{ warningText | translate }}
</div>
